<template>
  <section
    id="about"
    class="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
    aria-label="About me"
  >
    <div
      class="sticky top-0 z-20 -mx-6 mb-4 w-screen bg-slate-900/75 px-6 py-5 backdrop-blur md:-mx-12 md:px-12 lg:sr-only lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0"
    >
      <h2
        class="text-sm font-bold uppercase tracking-widest text-slate-200 lg:sr-only"
      >
        About
      </h2>
    </div>
    <div>
      <p class="mb-4">
        I'm a software engineer who works at the intersection of development and
        design, building digital products that are both functional and
        intuitive. I specialize in developing modern web applications across the
        front-end and back-end, with a focus on clean architecture,
        maintainability, performance, and user experience.
      </p>
      <p class="mb-4">
        With a background in UI/UX design, I bring a design-driven approach to
        development translating interfaces and concepts into responsive,
        production-ready experiences while keeping usability and technical
        quality in mind.
      </p>
      <p class="mb-4">
        I also leverage AI-assisted development tools to improve efficiency
        throughout the development process, from research and prototyping to
        debugging, code optimization, and problem-solving. I see AI as a tool
        that complements engineering expertise, helping me work faster while
        maintaining control over the quality, architecture, and decisions behind
        the code.
      </p>
      <p class="mb-4">
        From business systems and web applications to custom platforms and
        interactive experiences, I enjoy taking ideas from concept to
        implementation. I'm constantly learning, refining my approach, and
        exploring better ways to build reliable software that solves real
        problems.
      </p>
    </div>
  </section>
</template>
